import React from 'react';
//import { Link } from 'react-router-dom';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { deletegrievance, getCurrentProfile, clearProfile, getProfileById } from '../../actions/profile';

const DashboardActions = ({
  auth: { user },
  profile: { profile, gid },
  deletegrievance, getCurrentProfile, clearProfile, getProfileById
}
) => {


  const navigate = useNavigate();

  const goNext = async(gid) => {
    //clearProfile(history, "3");
    const temp = profile._aid;
    await clearProfile();
    await getProfileById(temp, gid);
    navigate("/upload");
  };

  const handleDeleteRow = async (i) => {
    const tobesent = {};
    tobesent._aid = profile._aid;
    tobesent.row = i;
    tobesent.gid = gid;
    console.log(tobesent);
    await deletegrievance(tobesent);        
    
  }

  const clearNextGetUpd = async() => {
    //clearProfile(history, "3");   
    const temp = profile.e;
    await clearProfile();
    await getCurrentProfile(temp);
    //navigate("/search-profile");
  }

  function searchfornull(arr, ele) {
    console.log("arr and ele", arr, ele);
    var fl = false;
    arr.forEach(element => {
      if(element._gid.toString() === ele.toString())
        fl = true
    });
    console.log("flag value is", fl);
    if (fl === false) {
      return <div>
        {/* <a key={ele} href="/upload" target="_blank" rel="noopener noreferrer" > Upload Letter is Pending </a> */}
        <button className="btn btn-light" onClick={i => goNext(ele)} > upload </button>
      </div>;
    }
    else 
    {
      return true
    }
  }

  const responses = profile !== null && profile !== undefined && profile.gr !== undefined && profile.cmts !== undefined && profile.cmts.length > 0 && profile.cmts.map((comment) => (
    <tr key={comment._id}>
        <td>{comment.rep}</td>  
    </tr>
  ));

  const grievances = profile !== null && profile !== undefined && profile.gr !== undefined && profile.gr.map((edu) => (
    <tr key={edu._id}>
      <td>{edu.gt}</td>      
      <td>{edu.st}</td>           
      <td> {moment(edu.d).format('DD/MM/YYYY')} </td>
      <td> {edu.tfcc} </td>
      <td>
      {((profile.gups !== undefined && profile.gups !== null) && profile.gups.filter((item => (item._gid === edu._gid)))).map((chk) => (
        <a key={chk._gid} href={chk.l} target="_blank" rel="noopener noreferrer" > Download Request Letter </a>
      ))}

      {searchfornull(profile.gups, edu._gid)}

      </td>     
      <td>
      {((profile.cmts !== undefined && profile.cmts !== null) && profile.cmts.filter((item => (item._gid === edu._gid)))).map((chk) => (
        <div>{chk.rep}</div>
      ))}
      </td>        
      { edu.st.toString() === "open" &&
      <td> <button className="btn btn-light" onClick={i => handleDeleteRow(edu._gid)} > delete </button> </td>      
      }
      
      {/* {edu.st.toString() === "closed" &&  */}
          <td> {edu.ct.n} - {edu.ct.m} - {edu.ct.rel}</td>
      {/* } */}
    </tr>
  ));


  return (
    <div className='dash-buttons'>     

      <Link to='/add-grievance' className='btn btn-primary'>
        <i className='fab fa-black-tie text-primary' />   Add New Grievance
      </Link>            
      {/* <Link to='/' className='btn btn-primary'>
        <i className='fab fa-black-tie text-primary' />   Add New Grievance
      </Link>  */}
      <input type="submit" className='btn btn-danger'  value="Refresh" onClick= {e => clearNextGetUpd(e)} />    

      <br/> Click refresh after adding new grievance <br/>

      {profile !== null && profile !== undefined &&
      <>
          <h3 className="my-2">Grievances List </h3>
          <table className="table">
            <thead>
              <tr>
                <th>Description</th>
                <th className="hide-sm">Status</th>
                <th className="hide-sm">Date</th>
                <th className="hide-sm">TFC</th>
                <th className="hide-sm">Request Letter</th>
                <th className="hide-sm">Admin response</th>                
                <th></th>
                <th className="hide-sm">Contact Details</th>
                <th/>
                <th />
              </tr>
            </thead>
            <tbody>{grievances}</tbody>
          </table>
      </>
      }      

    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  deletegrievance: PropTypes.func.isRequired,
  clearProfile: PropTypes.func.isRequired,
  getCurrentProfile: PropTypes.func.isRequired,
  getProfileById: PropTypes.func.isRequired
});

//export default DashboardActions;

export default connect(mapStateToProps, { deletegrievance, clearProfile, getCurrentProfile, getProfileById })(
  DashboardActions
);
